import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  static targets = ['template', 'container']

  declare readonly templateTarget: HTMLTemplateElement
  declare readonly containerTarget: HTMLElement

  connect (): void {
    console.log('Source cause nested form controller connected')
  }

  add (event: Event): void {
    event.preventDefault()

    const content = this.templateTarget.content.cloneNode(true) as DocumentFragment

    const timestamp = new Date().getTime().toString()
    const nestedFields = content.querySelectorAll('[data-nested-field]')

    nestedFields.forEach(field => {
      const name = field.getAttribute('name')
      if (name !== null) {
        field.setAttribute('name', name.replace(/NEW_RECORD/g, timestamp))

        const id = field.getAttribute('id')
        if (id !== null) {
          field.setAttribute('id', id.replace(/NEW_RECORD/g, timestamp))
        }
      }
    })

    this.containerTarget.appendChild(content)
  }

  remove (event: Event): void {
    event.preventDefault()

    const target = event.target as HTMLElement
    const item = target.closest('[data-nested-item]') as HTMLElement

    if (item == null) return

    const destroyField = item.querySelector("input[name*='[_destroy]']") as HTMLInputElement

    if (destroyField !== null) {
      destroyField.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
  }
}
